export var Permission;
(function (Permission) {
    Permission["PropertyListingCreate"] = "property-listing-create";
    Permission["PropertyListingRead"] = "property-listing-read";
    Permission["PropertyListingUpdate"] = "property-listing-update";
    Permission["PropertyTagCreate"] = "property-tags-create";
    Permission["PropertyTagRead"] = "property-tags-read";
    Permission["PropertyTagUpdate"] = "property-tags-update";
    Permission["PropertyTagDelete"] = "property-tags-delete";
    Permission["DirectorTypeCreate"] = "director-types-create";
    Permission["DirectorTypeRead"] = "director-types-read";
    Permission["DirectorTypeUpdate"] = "director-types-update";
    Permission["DirectorTypeDelete"] = "director-types-delete";
    Permission["MapGeoCreate"] = "map-geo-create";
    Permission["MapGeoRead"] = "map-geo-read";
    Permission["MapGeoUpdate"] = "map-geo-update";
    Permission["MapGeoDelete"] = "map-geo-delete";
    Permission["HomepageCreate"] = "homepage-create";
    Permission["HomepageRead"] = "homepage-read";
    Permission["HomepageUpdate"] = "homepage-update";
    Permission["HomepageDelete"] = "homepage-delete";
    Permission["AboutCreate"] = "about-create";
    Permission["AboutRead"] = "about-read";
    Permission["AboutUpdate"] = "about-update";
    Permission["AboutDelete"] = "about-delete";
    Permission["AnnouncementsCreate"] = "announcements-create";
    Permission["AnnouncementsRead"] = "announcements-read";
    Permission["AnnouncementsUpdate"] = "announcements-update";
    Permission["AnnouncementsDelete"] = "announcements-delete";
    Permission["ToursCreate"] = "tours-create";
    Permission["ToursRead"] = "tours-read";
    Permission["ToursUpdate"] = "tours-update";
    Permission["ToursDelete"] = "tours-delete";
    Permission["StoriesCreate"] = "stories-create";
    Permission["StoriesRead"] = "stories-read";
    Permission["StoriesUpdate"] = "stories-update";
    Permission["StoriesDelete"] = "stories-delete";
    Permission["CalendarEventCreate"] = "calendar-event-create";
    Permission["CalendarEventRead"] = "calendar-event-read";
    Permission["CalendarEventUpdate"] = "calendar-event-update";
    Permission["CalendarEventDelete"] = "calendar-event-delete";
    Permission["ResourcesRead"] = "resources-read";
    Permission["ResourcesUpdate"] = "resources-update";
    Permission["ResourcesDelete"] = "resources-delete";
    Permission["AdsCreate"] = "ads-create";
    Permission["AdsRead"] = "ads-read";
    Permission["AdsUpdate"] = "ads-update";
    Permission["AdsDelete"] = "ads-delete";
    Permission["BannersCreate"] = "banners-create";
    Permission["BannersRead"] = "banners-read";
    Permission["BannersUpdate"] = "banners-update";
    Permission["BannersDelete"] = "banners-delete";
    Permission["ThemeCreate"] = "theme-create";
    Permission["ThemeRead"] = "theme-read";
    Permission["ThemeUpdate"] = "theme-update";
    Permission["ThemeDelete"] = "theme-delete";
    Permission["DistrictUsersCreate"] = "district-users-create";
    Permission["DistrictUsersRead"] = "district-users-read";
    Permission["DistrictUsersUpdate"] = "district-users-update";
    Permission["DistrictUsersDelete"] = "district-users-delete";
    Permission["ModerationCreate"] = "moderation-create";
    Permission["ModerationRead"] = "moderation-read";
    Permission["ModerationUpdate"] = "moderation-update";
    Permission["ModerationDelete"] = "moderation-delete";
    Permission["KindAccessCreate"] = "kind-access-create";
    Permission["KindAccessRead"] = "kind-access-read";
    Permission["KindAccessUpdate"] = "kind-access-update";
    Permission["KindAccessDelete"] = "kind-access-delete";
    Permission["DiscussionKindsCreate"] = "discussion-kinds-create";
    Permission["DiscussionKindsRead"] = "discussion-kinds-read";
    Permission["DiscussionKindsUpdate"] = "discussion-kinds-update";
    Permission["DiscussionKindsDelete"] = "discussion-kinds-delete";
    Permission["CommunityInvite"] = "community-invite";
    Permission["SystemDistricts"] = "system-districts";
    Permission["SystemUsers"] = "system-users";
    Permission["SystemModeration"] = "system-moderation";
    Permission["SystemAnalytics"] = "system-analytics";
    Permission["SystemSettings"] = "system-settings";
    Permission["SystemLogs"] = "system-logs";
    Permission["SystemPolicies"] = "system-policies";
})(Permission || (Permission = {}));
export const PermissionSets = {
    propertyListing: {
        full: [
            Permission.PropertyListingCreate,
            Permission.PropertyListingRead,
            Permission.PropertyListingUpdate,
        ],
        readOnly: [Permission.PropertyListingRead],
    },
    propertyTags: {
        full: [
            Permission.PropertyTagCreate,
            Permission.PropertyTagRead,
            Permission.PropertyTagUpdate,
            Permission.PropertyTagDelete,
        ],
        readOnly: [Permission.PropertyTagRead],
    },
    directorTypes: {
        full: [
            Permission.DirectorTypeCreate,
            Permission.DirectorTypeRead,
            Permission.DirectorTypeUpdate,
            Permission.DirectorTypeDelete,
        ],
        readOnly: [Permission.DirectorTypeRead],
    },
    tours: {
        full: [
            Permission.ToursCreate,
            Permission.ToursRead,
            Permission.ToursUpdate,
            Permission.ToursDelete,
        ],
    },
    stories: {
        full: [
            Permission.StoriesCreate,
            Permission.StoriesRead,
            Permission.StoriesUpdate,
            Permission.StoriesDelete,
        ],
    },
    mapGeo: {
        full: [
            Permission.MapGeoCreate,
            Permission.MapGeoRead,
            Permission.MapGeoUpdate,
            Permission.MapGeoDelete,
        ],
        readOnly: [Permission.MapGeoRead],
    },
    content: {
        homepage: [
            Permission.HomepageCreate,
            Permission.HomepageRead,
            Permission.HomepageUpdate,
            Permission.HomepageDelete,
        ],
        about: [
            Permission.AboutCreate,
            Permission.AboutRead,
            Permission.AboutUpdate,
            Permission.AboutDelete,
        ],
        announcements: [
            Permission.AnnouncementsCreate,
            Permission.AnnouncementsRead,
            Permission.AnnouncementsUpdate,
            Permission.AnnouncementsDelete,
        ],
        events: [
            Permission.CalendarEventCreate,
            Permission.CalendarEventRead,
            Permission.CalendarEventUpdate,
            Permission.CalendarEventDelete,
        ],
        resources: [
            Permission.ResourcesRead,
            Permission.ResourcesUpdate,
            Permission.ResourcesDelete,
        ],
    },
    customization: {
        ads: [
            Permission.AdsCreate,
            Permission.AdsRead,
            Permission.AdsUpdate,
            Permission.AdsDelete,
        ],
        banners: [
            Permission.BannersCreate,
            Permission.BannersRead,
            Permission.BannersUpdate,
            Permission.BannersDelete,
        ],
        theme: [
            Permission.ThemeCreate,
            Permission.ThemeRead,
            Permission.ThemeUpdate,
            Permission.ThemeDelete,
        ],
    },
    districtUsers: {
        full: [
            Permission.DistrictUsersCreate,
            Permission.DistrictUsersRead,
            Permission.DistrictUsersUpdate,
            Permission.DistrictUsersDelete,
        ],
        readOnly: [Permission.DistrictUsersRead],
    },
    moderation: {
        full: [
            Permission.ModerationCreate,
            Permission.ModerationRead,
            Permission.ModerationUpdate,
            Permission.ModerationDelete,
        ],
        readOnly: [Permission.ModerationRead],
    },
    kindAccess: {
        full: [
            Permission.KindAccessCreate,
            Permission.KindAccessRead,
            Permission.KindAccessUpdate,
            Permission.KindAccessDelete,
        ],
        readOnly: [Permission.KindAccessRead],
    },
    discussionKinds: {
        full: [
            Permission.DiscussionKindsCreate,
            Permission.DiscussionKindsRead,
            Permission.DiscussionKindsUpdate,
            Permission.DiscussionKindsDelete,
        ],
        readOnly: [Permission.DiscussionKindsRead],
    },
    community: {
        invite: [Permission.CommunityInvite],
    },
    system: {
        districts: [Permission.SystemDistricts],
        users: [Permission.SystemUsers],
        moderation: [Permission.SystemModeration],
        analytics: [Permission.SystemAnalytics],
        settings: [Permission.SystemSettings],
        logs: [Permission.SystemLogs],
        policies: [Permission.SystemPolicies],
        full: [
            Permission.SystemDistricts,
            Permission.SystemUsers,
            Permission.SystemModeration,
            Permission.SystemAnalytics,
            Permission.SystemSettings,
            Permission.SystemLogs,
            Permission.SystemPolicies,
        ],
    },
};
